/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class ProductApi {
    static getInstance() {
        if (!this.instance) this.instance = new ProductApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取产品列表
    async getProductList (param, page_num, page_size){
        let url = `/api/product/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 新增产品
    async addProduct (param){
        let url = `/api/product`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 编辑产品
    async editProduct (param,id){
        let url = `/api/product/${id}`
        let result = await this.getData(url,param,'PUT')
        return result
    }

    // 删除产品
    async delProduct (id){
        let url = `/api/product/${id}`
        let result = await this.getData(url,{},'DELETE')
        return result
    }

    // 同步订单产品到ERP
    async syncProductInfo (){
        let url = `/api/product/update/order`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 获取仓库下拉
    async getWarehouse(){
        let url = `/api/order/warehouse`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 检验物料编码
    async checkInventory(param){
        let url = `/api/product/inventory`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 同步ERP产品到订单
    async syncERPToOrder(param){
        let url = `/api/product/update`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 导出产品excel
    async exportFile(param){
        let url = `/api/product/export/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取产品查询
    async getProductQuery(param){
        let url = `/api/product/mes/inventory`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取产品查询(按车型汇总)
    async getProductByModel(param){
        let url = `/api/product/mes/inventory/model`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 产品查询导出
    async exportProductQuery(param){
        let url = `/api/product/export/mes`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 产品查询导出(按车型汇总)
    async exportSummaryQuery(param){
        let url = `/api/product/export/mes/model`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取品牌名称
    async getBrandName(){
        let url = `/api/product/brand`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 获取零件名称
    async getPartName(){
        let url = `/api/product/parts`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 获取售后BOM物料
    async getEBikeBom(param){
        let url = `/api/product/erp/bom/query`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 获取交付报表列表(月)
    async getEBikeReportListByMonth(year, query_type, factors){
        let url = `/api/product/mes/inventory/plan?year=${year}&query_type=${query_type}&factors=${factors}`
        let result = await this.getData(url,{},'POST')
        return result
    }

    // 获取交付报表列表(周)
    async getEBikeReportListByWeek(year, query_type, begin_week, end_week, factors){
        let url = `/api/product/mes/inventory/plan?year=${year}&query_type=${query_type}&begin_week=${begin_week}&end_week=${end_week}&factors=${factors}`
        let result = await this.getData(url,{},'POST')
        return result
    }

    // 导出交付报表（月）
    async exportEBikeReportByMonth(year, query_type, factors){
        let url = `/api/product/export/mes/inventory/plan?year=${year}&query_type=${query_type}&factors=${factors}`
        let result = await this.getData(url,{},'POST')
        return result
    }

    // 导出交付报表（周）
    async exportEBikeReportByWeek(year, query_type, begin_week, end_week, factors){
        let url = `/api/product/export/mes/inventory/plan?year=${year}&query_type=${query_type}&begin_week=${begin_week}&end_week=${end_week}&factors=${factors}`
        let result = await this.getData(url,{},'POST')
        return result
    }

    // 获取计划列表
    async getPlanList(param, page_num, page_size){
        let url = `/api/product/plan/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 计划-交期变更
    async editPlanDate(param, id){
        let url = `/api/product/plan/edit/${id}`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 导出计划列表
    async exportPlanList(param){
        let url = `/api/product/plan/export/query`
        let result = await this.getData(url,param,'POST')
        return result
    }


    // 库存可用性-保存数量和交期
    async saveQtyPlanETA(param){
        let url = `/api/product/place/order/save`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 库存可用性-确认 数量和交期
    async confirmQtyPlanETA(){
        let url = `/api/product/place/order/confirm`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 查询拆分列表 
    async getSplitDe(param){
        let url = `/api/product/plan/query`
        let result = await this.getData(url,param,'POST')
        return result
    } 

    // 保存拆分sku
    async splitDelivery(param){
        let url = `/api/product/plan/split/sku`
        let result = await this.getData(url,param,'POST')
        return result
    } 

    // 获取批量编辑交期列表
    async getPlan(param){
        let url = `/api/product/plan/query`
        let result = await this.getData(url,param,'POST')
        return result
    } 

    // 批量编辑交期
    async batchEditDelivery(param){
        let url = `/api/product/plan/edit/batch`
        let result = await this.getData(url,param,'POST')
        return result
    } 

    // 根据SKU获取拆分数据
    async getSplitList(param){
        let url = `/api/product/plan/list/batch`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 提交拆分数据
    async saveSplitData(param){
        let url = `/api/product/plan/split/sku/batch`
        let result = await this.getData(url,param,'POST')
        return result
    }

    //获取Maisach数据
    async getMaisachList(param) {
        let url = `/api/product/plan/list/maisach`;
        let result = await this.getData(url, param,'GET');
        return result;
    }

    //更新Maisach库存
    async updateMaisachStock(param) {
        let url = `/api/product/plan/update/maisach/stock`;
        let result = await this.getData(url, param,'POST');
        return result;
    }

    // 历史记录查询
    async getRecordList(param,page_num,page_size){
        let url = `/api/product/plan/record/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }
}

export {
    ProductApi
}